import React, { useState } from 'react';
// antd
import { Dropdown, Menu, Typography } from 'antd';
import { DownloadOutlined, FileAddOutlined } from '@ant-design/icons';
// hoooks
import { useCheckPermissions, useGlobalModal } from 'hooks';
//
import Messages from 'i18n/messages/home';
import RunQueryControl from '../../controls/advanced-search/RunQueryControl';

import { Can } from 'context/Can';
// components
import { RibbonButton, RibbonSection } from 'common/components';
import ModalAddSearchProductToFolder from 'common/components/modal-add-search-product-to-folder/ModalAddSearchProductToFolder';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import { ADVANCED_FILTER_MODE } from 'pages/reporting/utils/constants';

const REPORT_EXPORT_TYPE_ADVANCED = ['XLS', 'XLSX', 'JSON', 'XML'];

const REPORT_EXPORT_TYPE_FLAT = ['XLS', 'XLSX', 'CSV', 'JSON', 'XML'];

const QuerySection = (props) => {
  const {
    disableRun,
    modeData,
    onClickRibbonBtn,
    disabledExportQuery,
    type,
    dataQueryConditions,
  } = props;
  const [loading, setLoading] = useState();

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const handleOpenModal = () => {
    openModal(MODAL_NAMES.ADD_SEARCH_PRODUCT_TO_FOLDER);
  };

  const hasPermissionAddToFolder = useCheckPermissions([
    { action: ABILITY_ACTION.EDIT, subject: ABILITY_SUBJECT.FOLDER },
  ]);

  const onClickRunBtn = () => {
    onClickRibbonBtn('run');
  };

  const onClickExportBtn = (exportType) => {
    setLoading(true);
    onClickRibbonBtn('export', { setLoading, exportType });
  };

  const exportType =
    modeData === ADVANCED_FILTER_MODE.NESTED_DATA
      ? REPORT_EXPORT_TYPE_ADVANCED
      : REPORT_EXPORT_TYPE_FLAT;

  const menu = (
    <Menu>
      {exportType.map((exportType) => {
        return (
          <Menu.Item
            onClick={() => {
              onClickExportBtn(exportType);
            }}
            key={exportType}
          >
            <Typography.Text
              strong
              style={{ cursor: 'pointer', padding: '0 16px 0 4px' }}
            >
              <DownloadOutlined style={{ marginRight: 4 }} /> {exportType}
            </Typography.Text>
          </Menu.Item>
        );
      })}
      {type === 'product' && (
        <Menu.Item onClick={handleOpenModal} key={'add-results-to-folder'}>
          <Typography.Text
            strong
            style={{ cursor: 'pointer', padding: '0 16px 0 4px' }}
          >
            <FileAddOutlined style={{ marginRight: 4 }} /> Add Results to Folder
          </Typography.Text>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <RibbonSection>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <RunQueryControl disabled={disableRun} onClick={onClickRunBtn} />
      </Can>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <Dropdown
          overlay={menu}
          overlayStyle={{ height: 200 }}
          disabled={disabledExportQuery}
        >
          <RibbonButton
            loading={loading}
            icon={<DownloadOutlined />}
            label={Messages.exportQuery}
            disabled={disabledExportQuery}
          />
        </Dropdown>
      </Can>
      <ModalAddSearchProductToFolder
        hasPermissionAddToFolder={hasPermissionAddToFolder}
        dataQueryConditions={dataQueryConditions}
      />
    </RibbonSection>
  );
};

export default QuerySection;
